import React from 'react';
import { useFulfillmentDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/store/fulfillmentDashboard.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';

export const UnfulfilledByPositionChart: React.FC = () => {
  const data = useFulfillmentDashboardStore((s) => s.fulfillmentByPosition);
  const palette = useChartColors();
  const barColor = palette.chartColors[3] || '#1B2A4A';

  if (!data || data.length === 0) {
    return <EmptyStateContainer>No data available</EmptyStateContainer>;
  }

  const items: HorizontalBarItem[] = data.map((d) => {
    const percentage = formatDashboardNumber(d.fulfillmentPercentage);
    return {
      label: d.position,
      value: d.fulfillmentPercentage,
      valueLabel: `${percentage}%`,
      ariaLabel: `${d.position}: ${percentage}% fulfillment (${d.totalShifts} shifts)`,
      tooltipHtml: `<strong>${d.position}</strong><br/>Fulfillment: ${percentage}%<br/>Shifts: ${d.totalShifts}`,
      barColor,
    };
  });

  return (
    <HorizontalBarChart
      items={items}
      maxValue={100}
      rightMargin={70}
      leftMargin={170}
      wrapLabels
      scrollable
      ariaLabel="Number of shifts fulfilled per positions"
    />
  );
};
